import React from 'react';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';

import './config/reactotron';

import Router from './routes';
import store, { history } from './store';

export default () => (
  <CookiesProvider>
    <Provider store={store}>
      <Router history={history} />
    </Provider>
  </CookiesProvider>
);



// WEBPACK FOOTER //
// ./src/App.js